import {TranslateService} from '@ngx-translate/core';

import {LocalizationService} from '../localization/localization.service';
import {format, strToDate} from '../utils/date';
import {isPresent} from '../utils/lang';

export class ChangeTrackingChanges {
  public groupName: string;
  public props: { [key: string]: any } = {};
  public before: { [key: string]: string } = {};
  public after: { [key: string]: string } = {};

  constructor(log: any,
              private translate: TranslateService,
              private localization: LocalizationService) {
    let groupZoneBefore: any = log.before || {},
      groupZoneAfter: any = log.after || {};

    if (!groupZoneBefore || !groupZoneAfter) {
      console.warn('No groups');
      return;
    }

    this.groupName = groupZoneBefore.groupName || groupZoneAfter.groupName;

    if (!this.groupName) {
      this.groupName = groupZoneBefore.groupZoneTransId
        || groupZoneAfter.groupZoneTransId
        || groupZoneBefore.Name
        || groupZoneAfter.Name
        || groupZoneBefore.Type
        || groupZoneAfter.Type
        || 'CHANGE_TRACKING.main_information';
      groupZoneBefore = {values: groupZoneBefore};
      groupZoneAfter = {values: groupZoneAfter};
    }


    delete groupZoneBefore.values['VariableType'];
    delete groupZoneBefore.values['ContractId'];
    delete groupZoneBefore.values['Name'];
    delete groupZoneAfter.values['VariableType'];
    delete groupZoneAfter.values['ContractId'];
    delete groupZoneAfter.values['Name'];


    this.collectValues(groupZoneBefore.values, 'before');
    this.collectValues(groupZoneAfter.values, 'after');


    if (log.item === 'REP_ENTITY') {
      this.groupName = 'CHANGE_TRACKING.main_information';
    }
  }

  private collectValues(values: any, state: string) {
    if (values.beginDate) {
      this[state].beginDate = format(strToDate(values.beginDate), this.localization.dateFormat);
      this.props.beginDate = true;
    }
    if (values.endDate) {
      this[state].endDate = format(strToDate(values.endDate), this.localization.dateFormat);
      this.props.endDate = true;
    }
    if (values.zones) {
      for (const key in values.zones) {
        this[state][values.zones[key].zoneTransId || key] = this.formatValue(values.zones[key]);
        this.props[values.zones[key].zoneTransId || key] = true;
      }
    }
  }

  private formatValue(zone: { value: any, type: string, valueTransId: string }) {
    const value = zone.value;
    const type = zone.type;

    if (!isPresent(value) || value.toString().replace(/\s/g, '') === '') {
      return;
    }

    switch (type) {
      case 'DATE':
        return format(strToDate(value), this.localization.dateFormat);
      case 'LIST':
      case 'ENTITY':
      case 'ENTITY_DATA':
      case 'ENTITY_PREFIXED':
      case 'TREE':
      case 'PEOPLE_TREE':
      case 'ACTIVE_EMPLOYEE':
        return (zone?.valueTransId) ? this.translate.instant(zone?.valueTransId) : zone?.value;
      case 'INTEGER':
        return this.localization.localizeNumber(value, 'INTEGER');
      case 'DECIMAL':
      case 'CURRENCY':
        return this.localization.localizeNumber(value, 'DECIMAL_UP_TO_4_DIGIT');
      case 'PERCENTAGE':
        if (isPresent(value) && value !== '' && !isNaN(value)) {
          return this.localization.localizeNumber(parseInt(value, 10) / 100, 'PERCENT_UP_TO_4_DIGIT');
        }
        // already formatted as percentage string xx.xx%
        return value;
      case 'BOOLEAN':
        if (value === true) {
          return '<i class="fa fa-light fa-check" aria-hidden="true"></i>';
        } else if (value === false) {
          return '<i class="fa fa-light fa-times" aria-hidden="true"></i>';
        }

        return value;
      default:
        return value;
    }
  }
}
